import { render } from "./CreateUpdateBudgetSection.vue?vue&type=template&id=94ce5cf0"
import script from "./CreateUpdateBudgetSection.vue?vue&type=script&lang=js"
export * from "./CreateUpdateBudgetSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__